module.exports = __webpack_public_path__ + "img/ventus-man.81b2cd11.jpeg";